module.exports = "pegasus_template/assets/graycircle-instagram.png";